type LoadingClassType = {
	height?: string;
	width?: string;
};

export const loadingClass = (option?: LoadingClassType) => {
	return `${option?.height ?? "h-4"} ${
		option?.width ?? "w-14"
	} animate-pulse bg-gray-300 bg-opacity-50 rounded-md`;
};
